import React, { useEffect, useState } from "react";

import {
  ArrowForward,
  ChevronLeft,
  Circle,
  Language,
  LocationOnOutlined,
  NoteOutlined,
} from "@mui/icons-material";
import {
  Box,
  Card,
  Button,
  Typography,
  IconButton,
  Divider,
  CircularProgress,
  Skeleton,
  Grid,
  Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import { connect, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import RESUMEICON from "../../assets/icons/resumeicon.png";
import { EmptyState } from "../../common";
import CandidateInformationSection from "../../common/CandidateInformationSection";
import CandidateQnaCard from "../../common/CandidateQnaCard";
import AttachmentsModal from "../../components/Modals/CandidateAttachementsModal";
import SelectAssesmentAndCriteriaModal from "../../components/Modals/SelectAssesmentAndCriteriaModal";
import {
  getSingleResume as getSingleResumeAction,
  inviteCandidatesForInterview as inviteCandidatesForInterviewAction,
  selectResumeById,
} from "../../redux/slices/resumeSlice";
import { profiles } from "../../static/socials-profiles";
import { getCamelCaseWord } from "../../utils/functions";
import SelectLanguageModal from "../../components/Modals/SelectAssesmentAndCriteriaModal/SelectLanguageModal";
import "../../common/share-button.css";
import ShareResultModal from "../../common/ShareResultModal";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
/* ============================================================================
<ResumeScreeningCandidateOverallResult />
============================================================================= */
const ResumeScreeningCandidateOverallResult = ({
  user,
  getSingleResume,
  inviteCandidatesForInterview,
}) => {
  const { postId, resumeId } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [inviteLoading, setInviteLoading] = useState(false);
  const [attachmentsModal, setAttachementsModal] = useState(false);
  const [
    selectAssessmentAndCriteriaModal,
    setSelectAssessmentAndCriteriaModal,
  ] = useState(false);
  const [pendingAssessmentId, setPendingAssessmentId] = useState(null);
  const [showLanguageSelectModal, setShowLanguageSelectModal] = useState(false);
  const [languagesForInterview, setLangaugesForInterview] = useState([]);
  const [interviewValue, setInterviewValue] = useState(77);
  const [passingCriteriaSet, setPassingCriteriaSet] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [openShareModal, setOpenShareModal] = useState(false);

  const resume = useSelector((state) => selectResumeById(state, resumeId));
  const post = resume?.job;
  const isResumeScoreCalculated =
    typeof resume?.score === "object" &&
    Object.keys(resume?.score || {}).length > 0;

  const socials =
    resume?.candidate?.social_profiles?.map((c) => ({
      ...c,
      isValid: c?.url && c?.url !== "N/A",
    })) || [];

  useEffect(() => {
    _getData();
  }, []);

  const _getData = async () => {
    setIsLoading(true);
    await getSingleResume(resumeId);
    setIsLoading(false);
  };

  const _toggleAttachementsModal = () => setAttachementsModal((prev) => !prev);

  const _toggleShareModal = () => setOpenShareModal((prev) => !prev);

  const handleInvite = async (assessment_id = post?.assesment_id) => {
    if (!assessment_id && !pendingAssessmentId) {
      return setSelectAssessmentAndCriteriaModal(true);
    }

    if (languagesForInterview?.length === 0) {
      return setShowLanguageSelectModal(true);
    }

    try {
      setInviteLoading("invite");
      await inviteCandidatesForInterview({
        job_post_id: post?.id,
        assessment_id: pendingAssessmentId,
        company_id: user?.company_id,
        resume_ids: [resume?.id],
        languages: languagesForInterview,
        passing_criteria: {
          interview_passing_criteria: interviewValue,
        },
      });
      await _getData();
    } catch (e) {
      enqueueSnackbar("Something went wrong while sending assessment request", {
        variant: "error",
      });
    } finally {
      setInviteLoading(false);
      setInterviewValue(77);
      setLangaugesForInterview([]);
      setPendingAssessmentId(null);
      setShowLanguageSelectModal(false);
      setPassingCriteriaSet(false);
    }
  };

  const extracted_data = resume?.resume?.extracted_data;

  if (!resume) {
    return (
      <Box className="center" height="89vh">
        <EmptyState title="Look's like the resume submition was deleted" />
      </Box>
    );
  }

  return (
    <>
      <Navbar />
      <Sidebar />
      <Card
        sx={{
          height: "90vh",
          borderRadius: "10px",
          left: "240px",
          width: "calc(100% - 233px)",
          position: "relative",
          mt: "2%",
        }}
      >
        <Card
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
            px: { xs: 2, md: 4 },
            py: 2,
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            gap={{ xs: 0, md: 2 }}
            flexDirection={{ xs: "column", md: "row" }}
          >
            <Box>
              <IconButton
                size="small"
                sx={{ border: "1px solid #B1B1B1" }}
                onClick={() =>
                  navigate(`/resume-screening-candidates/${postId}`)
                }
              >
                <ChevronLeft sx={{ fontSize: 18, color: "#2d2d2d" }} />
              </IconButton>
            </Box>
            <Box>
              <Typography fontSize="18px" fontWeight={600} color="#48555E">
                {resume?.candidate_name}
              </Typography>
              <Typography fontSize="14px" fontWeight={500} color="#48555E">
                {extracted_data?.candidate_email || "--"}
              </Typography>
            </Box>
            <Box>
              {extracted_data?.total_relevant_experience?.value ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <NoteOutlined sx={{ fontSize: "15px", color: "#48555E" }} />
                  <Typography fontSize="14px" fontWeight={600} color="#48555E">
                    {
                      resume?.resume?.extracted_data?.total_relevant_experience
                        ?.value
                    }
                  </Typography>
                </Box>
              ) : null}
              {extracted_data?.address?.value ||
              extracted_data?.location?.value ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <LocationOnOutlined
                    sx={{ fontSize: "15px", color: "#48555E" }}
                  />
                  <Typography fontSize="14px" fontWeight={600} color="#48555E">
                    {extracted_data?.address?.value ||
                      extracted_data?.location?.value}
                  </Typography>
                </Box>
              ) : null}
            </Box>
          </Box>

          {/* <Box
            display="flex"
            gap={2}
            justifyContent="center"
            alignItems="center"
          >
            <button
              type="button"
              class="button"
              onClick={() => setOpenShareModal(true)}
            >
              <span class="fold"></span>

              <div class="points_wrapper">
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
              </div>

              <span class="inner">
                <svg
                  class="icon"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2.5"
                >
                  <polyline points="13.18 1.37 13.18 9.64 21.45 9.64 10.82 22.63 10.82 14.36 2.55 14.36 13.18 1.37"></polyline>
                </svg>
                Share
              </span>
            </button>

            {resume?.stage !== "Invited" ? (
              <Button
                variant="main"
                disabled={inviteLoading}
                sx={{
                  fontSize: { xs: 14, md: 18 },
                  py: { xs: 0.5, md: 1 },
                  borderRadius: { xs: "5px", md: "30px" },
                  px: { xs: 2, md: 4 },
                }}
                onClick={() => handleInvite()}
              >
                {inviteLoading ? (
                  <CircularProgress size={20} sx={{ color: "white" }} />
                ) : (
                  "Invite +"
                )}
              </Button>
            ) : null}
          </Box> */}
        </Card>
        <Box display="flex">
          <Box p={4} flexBasis="20%" flexGrow={1}>
            <Box mb={3}>
              <Typography fontWeight={600} fontFamily="Outfit">
                Invited
              </Typography>
              {isLoading ? (
                <Skeleton animation="wave" width="100%" height="30px" />
              ) : (
                <Typography fontSize="15px" fontFamily="Outfit">
                  {/* {dayjs(resume?.created_at).format("LL")} */}
                  {dayjs(resume.created_at).format("MMM DD, YYYY")}
                </Typography>
              )}
            </Box>
            <Box mb={3}>
              <Typography fontWeight={600} fontFamily="Outfit">
                Completed
              </Typography>
              {isLoading ? (
                <Skeleton animation="wave" width="100%" height="30px" />
              ) : (
                <Typography fontSize="15px" fontFamily="Outfit">
                  {/* {dayjs(resume?.resume?.created_at).format("LL")} */}
                  {dayjs(resume?.resume?.created_at).format("MMM DD, YYYY")}
                </Typography>
              )}
            </Box>
            {/* <Box mb={3}>
            <Typography fontWeight={600} fontFamily="Outfit">Extra time breakdown</Typography>
            <Box component="ul" sx={{ listStyleType: 'disc', paddingLeft: 2 }}>
              <li>
                {isLoading ? <Skeleton animation='wave' width='100%' height='22px' /> : <Typography fontSize="15px" fontFamily="Outfit">Not fluent in English +20%</Typography>}
              </li>
              <li>
                {isLoading ? <Skeleton animation='wave' width='100%' height='22px' /> : <Typography fontSize="15px" fontFamily="Outfit">Disability +50%</Typography>}
              </li>
            </Box>
          </Box> */}
            <Box mb={3}>
              <Typography fontWeight={600} fontFamily="Outfit">
                Source
              </Typography>
              {isLoading ? (
                <Skeleton animation="wave" width="100%" height="30px" />
              ) : (
                <Typography fontSize="15px" fontFamily="Outfit">
                  {post?.flow === "2"
                    ? "Resume was manually uploaded"
                    : "Resume received via job post"}
                </Typography>
              )}
            </Box>
          </Box>
          {isLoading ? (
            <Box
              flexBasis="90%"
              flexGrow={1}
              height="70vh"
              overflow="auto"
              className="center"
            >
              <CircularProgress size={35} />
            </Box>
          ) : (
            <Box
              flexBasis="90%"
              flexGrow={1}
              p={3}
              height="80vh"
              overflow="auto"
            >
              <Box display="flex" alignItems="center" gap={2} mb={2}>
                <Typography variant="h4" fontWeight={700} fontFamily="Roboto">
                  Overall Result
                </Typography>
              </Box>

              <Box width="100%" my={4}>
                <Box display="flex" alignItems="center" gap={1.5} mb={1}>
                  <img src={RESUMEICON} height={40} />
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    fontFamily="Roboto"
                  >
                    Resume score
                  </Typography>
                </Box>

                <Card
                  sx={{
                    bgcolor: "#FBFBFB",
                    px: { xs: 2, lg: 5 },
                    py: 3,
                    gap: 2,
                    border: 1,
                    borderColor: "#DDE3E5",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box width={{ xs: "15.625rem" }}>
                    <CircularProgressbarWithChildren
                      value={resume?.resume_score || 0}
                      strokeWidth={10}
                      styles={buildStyles({
                        rotation: 0.75,
                        strokeLinecap: "round",
                        pathColor: "#4BC7E1",
                        trailColor: "#61E4FF30",
                      })}
                    >
                      <Typography
                        color={"#4BC7E1"}
                        textAlign="center"
                        fontSize={{ xs: "1rem", md: "2rem" }}
                        fontWeight={700}
                        mb={1.4}
                      >
                        {`${Math.floor(resume?.resume_score || 0)}%`}
                        <Typography
                          fontSize={{ xs: ".5rem", md: ".7rem" }}
                          fontWeight={500}
                        >
                          Average score
                        </Typography>
                      </Typography>
                    </CircularProgressbarWithChildren>
                  </Box>
                  <Box>
                    <Typography
                      color="#586B77"
                      fontSize="12px"
                      fontWeight={500}
                      textTransform="uppercase"
                    >
                      Top attributes
                    </Typography>
                    <Grid container spacing={2}>
                      {isResumeScoreCalculated
                        ? Object.keys(resume?.score || {})
                            .slice(0, 4)
                            ?.map((c, i) => (
                              <Grid
                                key={i}
                                item
                                size={{ xs: 8, md: 6 }}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 2,
                                }}
                              >
                                <Typography
                                  fontSize={{ xs: ".7rem", md: ".9rem" }}
                                  fontWeight={500}
                                  flex={0.5}
                                  display="flex"
                                  alignItems="center"
                                  gap={1}
                                >
                                  <Circle
                                    sx={{ width: "5px", height: "5px" }}
                                  />
                                  {c === "skills"
                                    ? "Technical Skills"
                                    : getCamelCaseWord(c)}
                                </Typography>
                                <Box
                                  width={{ xs: "40px", md: "3.2rem" }}
                                  height={{ xs: "40px", md: "3.2rem" }}
                                >
                                  <CircularProgressbarWithChildren
                                    value={resume?.score[c]?.matching_score}
                                    strokeWidth={10}
                                    styles={buildStyles({
                                      rotation: 0.75,
                                      strokeLinecap: "round",
                                      pathColor: `#4BC7E1`,
                                      trailColor: "#E6D5FF",
                                    })}
                                  >
                                    <Typography
                                      color="#4BC7E1"
                                      textAlign="center"
                                      fontSize={{ xs: "0.7rem" }}
                                      fontWeight={700}
                                      mb={1.4}
                                    >
                                      {`${Math.floor(
                                        resume?.score[c]?.matching_score
                                      )}%`}
                                    </Typography>
                                  </CircularProgressbarWithChildren>
                                </Box>
                              </Grid>
                            ))
                        : post?.job_criteria?.slice(0, 4)?.map((c, i) => (
                            <Grid
                              key={i}
                              item
                              size={{ xs: 8, md: 6 }}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                              }}
                            >
                              <Typography
                                fontSize={{ xs: "13px", md: ".9rem" }}
                                fontWeight={500}
                                flex={0.5}
                                display="flex"
                                alignItems="center"
                                gap={1}
                              >
                                <Circle sx={{ width: "5px", height: "5px" }} />
                                {getCamelCaseWord(c?.name)}
                              </Typography>
                              <Box
                                width={{ xs: "40px", md: "3.2rem" }}
                                height={{ xs: "40px", md: "3.2rem" }}
                              >
                                <CircularProgressbarWithChildren
                                  value={0}
                                  strokeWidth={10}
                                  styles={buildStyles({
                                    rotation: 0.75,
                                    strokeLinecap: "round",
                                    pathColor: `#4BC7E1`,
                                    trailColor: "#E6D5FF",
                                  })}
                                >
                                  <Typography
                                    color="#4BC7E1"
                                    textAlign="center"
                                    fontSize={{ xs: "13px" }}
                                    fontWeight={700}
                                    mb={1.4}
                                  >
                                    {`${Math.floor(0)}%`}
                                  </Typography>
                                </CircularProgressbarWithChildren>
                              </Box>
                            </Grid>
                          ))}
                    </Grid>
                  </Box>
                  <Divider
                    orientation="vertical"
                    sx={{ height: "150px", bgcolor: "#B7B7B7" }}
                  />
                  <Button
                    variant="main"
                    endIcon={<ArrowForward />}
                    sx={{
                      bgcolor: "#4DD0E1",
                      color: "white",
                      textWrap: "noWrap",
                      borderRadius: "50px",
                      border: "1px solid transparent",
                      py: 1.5,
                      px: { xs: 1, lg: 4 },
                      fontSize: "1em",
                      fontWeight: 500,
                      ml: "2%",
                      "&:hover": {
                        bgcolor: "#26C6DA",
                      },
                    }}
                    // eslint-disable-next-line no-restricted-globals
                    onClick={() => navigate(`${location.pathname}/full-report`)}
                  >
                    See full report
                  </Button>
                </Card>
              </Box>

              <CandidateInformationSection extracted_data={extracted_data} />

              {/* {socials?.length > 0 && ( */}
              <Box sx={{ width: "100%", py: 4 }}>
                <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
                  Social Profiles
                </Typography>

                <Box sx={{ display: "flex", gap: 2, overflowX: "auto", pb: 2 }}>
                  {profiles.map((profile, index) => {
                    const matchedProfile = socials.find(
                      (social) =>
                        social?.name?.toLowerCase() ===
                        profile?.name?.toLowerCase()
                    );
                    const url = matchedProfile?.url || "";
                    const isValidUrl = !!url && url !== "N/A";

                    return (
                      <Box
                        key={index}
                        sx={{
                          minWidth: 200,
                          p: 3,
                          borderRadius: "8px",
                          border: "1px solid #d1d1d1",
                          backgroundColor: profile.bgColor || "#F1F5F9",
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <Box sx={{ color: profile.iconColor || "#0077B5" }}>
                          {profile.icon || <Language sx={{ fontSize: 44 }} />}
                        </Box>
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          {profile.name} Profile
                        </Typography>
                        <Tooltip
                          title={
                            !isValidUrl ? "URL not provided by the user." : ""
                          }
                        >
                          <span>
                            <Button
                              variant="contained"
                              sx={{
                                width: "100%",
                                backgroundColor: isValidUrl
                                  ? profile.buttonBg || "#0077B5"
                                  : "#B0BEC5",
                                color: "white",
                                borderRadius: "30px",
                                textTransform: "none",
                                "&:hover": {
                                  backgroundColor: isValidUrl
                                    ? profile.buttonBg || "#0077B5"
                                    : "#B0BEC5",
                                  opacity: isValidUrl ? 0.9 : 1,
                                },
                              }}
                              onClick={() =>
                                isValidUrl && window.open(url, "_blank")
                              }
                              disabled={!isValidUrl}
                            >
                              {"View Profile"}
                            </Button>
                          </span>
                        </Tooltip>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
              {/* )} */}
              {resume?.custom_qna_result?.questions?.map((item) => (
                <CandidateQnaCard qna={item} key={item?.question} />
              ))}
            </Box>
          )}
        </Box>
        {resume?.resume?.attachements && (
          <AttachmentsModal
            open={attachmentsModal}
            onClose={_toggleAttachementsModal}
            attachments={resume?.resume?.attachements}
          />
        )}

        <SelectAssesmentAndCriteriaModal
          open={selectAssessmentAndCriteriaModal}
          onClose={() => setSelectAssessmentAndCriteriaModal(false)}
          onSelect={(assessmentId) => {
            setPendingAssessmentId(assessmentId);
            handleInvite(assessmentId);
          }}
        />

        <SelectLanguageModal
          open={showLanguageSelectModal}
          actionLoading={inviteLoading}
          passingCriteriaSet={passingCriteriaSet}
          setPassingCriteriaSet={setPassingCriteriaSet}
          interviewValue={interviewValue}
          setInterviewValue={setInterviewValue}
          setShowLanguageSelectModal={setShowLanguageSelectModal}
          onClose={() => {
            setShowLanguageSelectModal(false);
            setLangaugesForInterview([]);
            setPassingCriteriaSet(false);
            setPendingAssessmentId(null);
            setInterviewValue(77);
          }}
          onSelect={(selectedLanguages) => {
            console.log("selected", selectedLanguages);
            setLangaugesForInterview(selectedLanguages);
          }}
          onConfirm={() => {
            handleInvite();
          }}
        />

        <ShareResultModal
          open={openShareModal}
          onClose={_toggleShareModal}
          title={resume?.candidate_name}
          resumeId={resume?.id}
          type="resume"
        />
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDipatchToProps = {
  getSingleResume: getSingleResumeAction,
  inviteCandidatesForInterview: inviteCandidatesForInterviewAction,
};

/* Export
============================================================================= */
export default connect(
  mapStateToProps,
  mapDipatchToProps
)(ResumeScreeningCandidateOverallResult);
